import { styled } from '../jss-style';
import sliderStyle from './slider';

const useSliderStyle = styled(sliderStyle, 'slider');
export { sliderStyle, useSliderStyle };
export default useSliderStyle;
